/**
 * Redacts Personal Identifiable Information (PII) from text.
 * Covers global phone numbers, email addresses, and SSN formats.
 */

// Regex patterns for PII detection
const EMAIL_REGEX = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;

// Matches various global phone number formats (e.g., +1-555-555-5555, (555) 555-5555, +44 20 7123 1234, etc.)
const PHONE_REGEX = /(\+?\d{1,3}[\s-]?)?(\(?\d{3}\)?[\s-]?)?\d{3}[\s-]?\d{4}/g;

// Matches standard US SSN format: XXX-XX-XXXX
const SSN_REGEX = /\b\d{3}-\d{2}-\d{4}\b/g;

export const redactPII = (text) => {
    if (!text || typeof text !== "string") return text;

    let redactedText = text;

    // Redact emails
    redactedText = redactedText.replace(EMAIL_REGEX, "[RESTRICTED_EMAIL]");

    // Redact phone numbers
    // Note: Phone regex can sometimes be aggressive, so we apply it carefully.
    redactedText = redactedText.replace(PHONE_REGEX, () => {
        // Basic check: if it's just a regular number without typical phone structure, we might want to skip. 
        // But for a secure chat, better safe than sorry.
        return "[RESTRICTED_PHONE]";
    });

    // Redact SSN
    redactedText = redactedText.replace(SSN_REGEX, "[RESTRICTED_SSN]");

    return redactedText;
};

/**
 * Checks if a string contains any blocked explicit keywords.
 * (This is a simplified example. In production, use backend AI filters).
 */
export const containsExplicitKeywords = (text) => {
    if (!text || typeof text !== "string") return false;
    const BLOCKED_WORDS = ["kill", "suicide", "murder", "nsfw_keyword_here"]; // Expand as needed
    const lowerText = text.toLowerCase();
    return BLOCKED_WORDS.some(word => lowerText.includes(word));
};
